export default "__VITE_ASSET__CBH3CJ4l__"